// extracted by mini-css-extract-plugin
export default {"pageContainer":"calendars_pageContainer__BEz5o","customTab":"calendars_customTab__ydG5F","customTabSelected":"calendars_customTabSelected__lJQDi"};